import { Button, Col, Input, List, Row, Space } from "antd"
import InlineEditor from "../InlineEditor"
import { PlusCircleOutlined } from '@ant-design/icons'
import { InfoLinkActionType as ActionType, infoLinkDeleted, InfoLink, Action } from "./proposalsModel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import { red } from "@ant-design/colors"

export type Props = {
  links: InfoLink[],
  dispatch: (a: Action) => void,
  redesign?: boolean,
}

export default function InfoLinks({ links, dispatch, redesign = false }: Props) {
  const deleteButton = (link: InfoLink) => <Button
    type='link'
    aria-label="delete"
    icon={<FontAwesomeIcon icon={faTrash} style={{ color: red.primary }} />}
    onClick={() => dispatch(infoLinkDeleted(link.id))}
  />

  if (redesign) {
    return <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {links.map(link => <Row key={link.id} gutter={12} align="middle" style={{ width: '100%' }}>
        <Col flex="auto">
          <Input
            value={link.url}
            placeholder="https://example.com"
            aria-label="Link URL"
            onChange={e => dispatch({ type: ActionType.UrlChanged, url: e.target.value, id: link.id })}
          />
        </Col>
        <Col flex="0 0 280px">
          <Input
            value={link.title}
            placeholder="Label"
            aria-label="Link label"
            onChange={e => dispatch({ type: ActionType.TitleChanged, title: e.target.value, id: link.id })}
          />
        </Col>
        <Col flex="none">{deleteButton(link)}</Col>
      </Row>)}

      <Row justify="end">
        <Button
          icon={<PlusCircleOutlined />}
          onClick={() => dispatch({ type: ActionType.Added })}
        >
          Add
        </Button>
      </Row>
    </Space>
  }

  return <>
    {links.length > 0 && <List
      itemLayout='horizontal'
      dataSource={links}
      split={false}
      renderItem={(link) => (
        <List.Item
          style={{ padding: '0px' }}
          actions={[deleteButton(link)]}  >
          <Row style={{ width: '100%' }}>
            <Col span={8}>
              <InlineEditor
                value={link.title}
                placeholder="Display Text"
                onChange={value => dispatch({ type: ActionType.TitleChanged, title: value, id: link.id })}
                style={{ fontWeight: '600' }}
              />
            </Col>
            <Col span={16}>
              <InlineEditor
                value={link.url}
                placeholder="https://example.com"
                onChange={value => dispatch({ type: ActionType.UrlChanged, url: value, id: link.id })}
              />
            </Col>
          </Row>
        </List.Item>
      )}
    />}

    <Button
      type='link'
      icon={<PlusCircleOutlined />}
      onClick={() => dispatch({ type: ActionType.Added })}
    >
      Add a new info link
    </Button>
  </>
}
